<div class="gm-shell">
  <header class="gm-topbar">
    <div class="gm-brand">
      <span class="gm-mark"></span>
      <span class="gm-title">Media Library</span>
    </div>

    <div class="gm-search" [formGroup]="searchForm">
      <mat-icon class="gm-search-icon">search</mat-icon>
      <input
        formControlName="query"
        placeholder="Search by title, caption, description, or category…"
      />
    </div>

    <div class="gm-actions">
      <button mat-button class="gm-action-btn" (click)="toggleArchivedView()">
        <mat-icon>{{ showArchived ? 'unarchive' : 'archive' }}</mat-icon>
        <span>{{ showArchived ? 'Show active' : 'Show archived' }}</span>
      </button>

      <button
        mat-raised-button
        class="gm-action-btn gm-ali"
        (click)="attachMedia()"
        [disabled]="isUploading || isAnalyzing"
      >
        <mat-icon>attach_file</mat-icon>
        <span>Attach media</span>
      </button>

      <button
        mat-raised-button
        color="primary"
        class="gm-primary-btn"
        (click)="uploadMedia()"
        [disabled]="isUploading || isAnalyzing || !selectedFiles.length"
      >
        <mat-icon *ngIf="!isUploading">cloud_upload</mat-icon>
        <mat-spinner
          *ngIf="isUploading"
          diameter="20"
          color="accent"
          class="white-spinner"
        ></mat-spinner>
        <span *ngIf="!isUploading">Upload media</span>
        <span *ngIf="isUploading">Uploading…</span>
      </button>

      <input
        #fileUploadInput
        type="file"
        multiple
        id="fileUpload"
        accept="image/*,video/*,audio/*,.jpg,.jpeg,.png,.webp,.gif,.mp4,.mov,.avi,.mkv,.mp3,.ogg,.wav"
        (change)="onFileSelected($event)"
        hidden
      />
    </div>
  </header>

  <section class="gm-filters">
    <div class="gm-pills">
      <button
        mat-stroked-button
        class="gm-pill"
        [class.active]="selectedMediaType === 'all'"
        (click)="selectMediaType('all')"
      >
        All
      </button>

      <button
        mat-stroked-button
        class="gm-pill"
        [class.active]="selectedMediaType === 'image'"
        (click)="selectMediaType('image')"
      >
        <mat-icon>image</mat-icon>
        Images
      </button>

      <button
        mat-stroked-button
        class="gm-pill"
        [class.active]="selectedMediaType === 'video'"
        (click)="selectMediaType('video')"
      >
        <mat-icon>videocam</mat-icon>
        Videos
      </button>

      <button
        mat-stroked-button
        class="gm-pill"
        [class.active]="selectedMediaType === 'audio'"
        (click)="selectMediaType('audio')"
      >
        <mat-icon>audiotrack</mat-icon>
        Audio
      </button>
    </div>

    <div class="gm-categories" *ngIf="categories.length">
      <button
        mat-stroked-button
        class="gm-pill"
        [class.active]="!selectedCategory"
        (click)="selectCategory(null)"
      >
        All categories
      </button>

      <button
        mat-stroked-button
        class="gm-pill"
        *ngFor="let cat of categories"
        [class.active]="cat === selectedCategory"
        (click)="selectCategory(cat)"
      >
        {{ cat }}
      </button>
    </div>
  </section>

  <section class="gm-upload" *ngIf="selectedFiles.length">
    <div class="gm-upload-card">
      <div class="gm-upload-header">
        <div class="gm-upload-title">
          <mat-icon>attach_file</mat-icon>
          <div>
            <div class="gm-upload-h1">Media attached</div>
            <div class="gm-upload-sub">
              {{ selectedFiles.length }} file(s) attached — click <b>Upload media</b>
              to save and analyze.
            </div>
          </div>
        </div>

        <div class="gm-upload-cta">
          <button
            mat-button
            class="gm-muted-btn"
            (click)="clearSelectedFiles()"
            [disabled]="isUploading || isAnalyzing"
          >
            Clear
          </button>
        </div>
      </div>

      <div class="gm-upload-grid">
        <div class="gm-upload-files">
          <div class="gm-file-row" *ngFor="let f of selectedFiles">
            <mat-icon>{{ getMediaIcon(detectFileType(f.type)) }}</mat-icon>
            <div class="gm-file-meta">
              <div class="gm-file-name">{{ f.name }}</div>
              <div class="gm-file-sub">{{ formatFileSize(f.size) }}</div>
            </div>
          </div>
        </div>

        <div class="gm-upload-form" [formGroup]="uploadForm">
          <fieldset
            [disabled]="isUploading || isAnalyzing"
            style="border: none; padding: 0; margin: 0;"
          >
            <mat-form-field appearance="outline" class="gm-field">
              <mat-label>Batch Title</mat-label>
              <input
                matInput
                formControlName="title"
                placeholder="Common title for all files"
              />
            </mat-form-field>

            <mat-form-field appearance="outline" class="gm-field">
              <mat-label>Category (optional)</mat-label>
              <input
                matInput
                formControlName="category"
                placeholder="e.g. Work, Travel..."
              />
            </mat-form-field>
          </fieldset>
        </div>
      </div>
    </div>
  </section>

  <section class="gm-upload" *ngIf="analysisPanel.visible">
    <div class="gm-upload-card">
      <div class="gm-upload-header">
        <div class="gm-upload-title">
          <mat-icon [class.gm-uploading-icon]="isAnalyzing">
            {{
              analysisPanel.state === 'failed'
                ? 'error'
                : (analysisPanel.state === 'ready'
                    ? 'check_circle'
                    : 'smart_toy')
            }}
          </mat-icon>

          <div>
            <div class="gm-upload-h1">{{ analysisPanel.title }}</div>
            <div class="gm-upload-sub">{{ analysisPanel.message }}</div>
          </div>
        </div>

        <div class="gm-upload-cta">
          <button mat-button class="gm-muted-btn" (click)="dismissAnalysisPanel()">
            Dismiss
          </button>
        </div>
      </div>

      <div
        class="gm-progress-container"
        *ngIf="analysisPanel.state === 'processing' || analysisPanel.state === 'uploading'"
      >
        <div class="gm-progress-label">
          <span>Analysis Progress</span>
          <span>{{ analysisPanel.progress }}%</span>
        </div>

        <mat-progress-bar
          mode="determinate"
          [value]="analysisPanel.progress"
        ></mat-progress-bar>
      </div>
    </div>
  </section>

  <section class="gm-section" *ngIf="filteredPinned.length">
    <div class="gm-section-header">
      <div class="gm-section-title">Pinned</div>
    </div>

    <div
      class="gm-grid"
      cdkDropList
      [cdkDropListData]="filteredPinned"
      (cdkDropListDropped)="dropPinned($event)"
    >
      <article
        class="gm-card"
        *ngFor="let media of filteredPinned; trackBy: trackById"
        cdkDrag
        [cdkDragData]="media"
      >
        <div class="gm-card-top">
          <div class="gm-badge">
            <mat-icon>{{ getMediaIcon(media.mediaType) }}</mat-icon>
          </div>

          <div class="gm-card-actions">
            <button mat-icon-button (click)="togglePinned(media, false)">
              <mat-icon>push_pin</mat-icon>
            </button>
            <button mat-icon-button (click)="editMedia(media)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="delete(media)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="gm-card-title">{{ media.title || media.fileName }}</div>

        <div class="gm-preview">
          <div class="gm-processing" *ngIf="isMediaProcessing(media)">
            <mat-spinner diameter="36"></mat-spinner>
          </div>

          <ng-container *ngIf="!isMediaProcessing(media)">
            <img
              *ngIf="media.mediaType === 'image'"
              [src]="getThumbnailUrl(media)"
              class="gm-img"
              (error)="handleImageError($event)"
            />

            <video
              *ngIf="media.mediaType === 'video'"
              [src]="media.mediaUrl"
              class="gm-img"
              controls
              muted
              playsinline
            ></video>
          </ng-container>
        </div>

        <div class="gm-meta">
          <div class="gm-chip-row">
            <span class="gm-chip" *ngIf="media.category">{{ media.category }}</span>
          </div>

          <div class="gm-file-sub" *ngIf="media.caption">
            {{ media.caption }}
          </div>

          <div class="gm-file-sub" *ngIf="media.description">
            {{ media.description }}
          </div>

          <div class="gm-chip-row" *ngIf="media.labels && media.labels.length">
            <span class="gm-chip" *ngFor="let cat of media.labels">
              {{ cat }}
            </span>
          </div>

          <div class="gm-file-sub" *ngIf="isMediaFailed(media)">
            N/A (analysis failed) — media saved, you can edit details manually.
          </div>

          <div class="gm-foot">
            <span>{{ formatFileSize(media.fileSize) }}</span>
            <span>{{ formatDate(media.createdAt) }}</span>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="gm-section" *ngIf="filteredOthers.length">
    <div class="gm-section-header">
      <div class="gm-section-title">Library</div>
    </div>

    <div
      class="gm-grid"
      cdkDropList
      [cdkDropListData]="filteredOthers"
      (cdkDropListDropped)="dropOthers($event)"
    >
      <article
        class="gm-card"
        *ngFor="let media of filteredOthers; trackBy: trackById"
        cdkDrag
        [cdkDragData]="media"
      >
        <div class="gm-card-top">
          <div class="gm-badge">
            <mat-icon>{{ getMediaIcon(media.mediaType) }}</mat-icon>
          </div>

          <div class="gm-card-actions">
            <button mat-icon-button (click)="togglePinned(media, true)">
              <mat-icon>push_pin</mat-icon>
            </button>
            <button mat-icon-button (click)="editMedia(media)">
              <mat-icon>edit</mat-icon>
            </button>
            <button mat-icon-button (click)="delete(media)">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>

        <div class="gm-card-title">{{ media.title || media.fileName }}</div>

        <div class="gm-preview">
          <div class="gm-processing" *ngIf="isMediaProcessing(media)">
            <mat-spinner diameter="36"></mat-spinner>
          </div>

          <ng-container *ngIf="!isMediaProcessing(media)">
            <img
              *ngIf="media.mediaType === 'image'"
              [src]="getThumbnailUrl(media)"
              class="gm-img"
              (error)="handleImageError($event)"
            />

            <video
              *ngIf="media.mediaType === 'video'"
              [src]="media.mediaUrl"
              class="gm-img"
              controls
              muted
              playsinline
            ></video>
          </ng-container>
        </div>

        <div class="gm-meta">
          <div class="gm-chip-row">
            <span class="gm-chip" *ngIf="media.category">{{ media.category }}</span>
          </div>

          <div class="gm-file-sub" *ngIf="media.caption">
            {{ media.caption }}
          </div>

          <div class="gm-file-sub" *ngIf="media.description">
            {{ media.description }}
          </div>

          <div class="gm-chip-row" *ngIf="media.labels && media.labels.length">
            <span class="gm-chip" *ngFor="let cat of media.labels">
              {{ cat }}
            </span>
          </div>

          <div class="gm-file-sub" *ngIf="isMediaFailed(media)">
            N/A (analysis failed) — media saved, you can edit details manually.
          </div>

          <div class="gm-card-bottom">
            <button mat-icon-button (click)="useInChat(media)">
              <mat-icon>send</mat-icon>
            </button>

            <button mat-icon-button (click)="archive(media)">
              <mat-icon>{{ media.archived ? 'unarchive' : 'archive' }}</mat-icon>
            </button>
          </div>
        </div>
      </article>
    </div>
  </section>

  <section class="gm-empty" *ngIf="!filteredPinned.length && !filteredOthers.length">
    <mat-icon>folder_open</mat-icon>
    <div class="gm-empty-title">No media found</div>
    <button mat-raised-button color="primary" (click)="attachMedia()">
      Attach media
    </button>
  </section>
</div>
